import serverCode from '../../serverCode'

const defaultState = () => ({
  items: [],
  paged: 0,
  length: 0,

  homeItems: [],

  filterStatus: {
    scheduleType: 1, // 1:開催前, 2:開催後, 3:本日開催
    onlyFree: false,
    onlyOnline: false,
    onlyReservation: false,
  },
})

const state = defaultState()

const mutations = {
  incrementPage(state) {
    state.paged++
  },
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  setHomeItems(state, payload) {
    state.homeItems = state.homeItems.concat(payload)
  },
  setFilterStatus(state, { key, value }) {
    state.filterStatus[key] = value
  },
  init(state) {
    Object.assign(state, defaultState())
  },
  resetItemsOnly(state) {
    state.items = []
    state.paged = 0
    state.length = 0
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems(
    { state, commit, rootState },
    { perPage, scheduleType, onlyFree, onlyOnline, onlyReservation }
  ) {
    try {
      const { succeed, events } = await serverCode(
        'getEvents',
        {
          offset: state.paged * perPage,
          perPage,
          scheduleType,
          onlyFree,
          onlyOnline,
          onlyReservation,
        },
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', events)
      }
    } catch (error) {
      //
    }
  },
  async getHomeItems({ state, commit, rootState }, { perPage, scheduleType }) {
    try {
      const { succeed, events } = await serverCode(
        'getEvents',
        {
          offset: 0,
          perPage,
          scheduleType,
        },
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setHomeItems', events)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
